import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Steps } from 'antd';
import classnames from 'classnames';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';

import { ExpiredTooltip, AlertIcon, Tag } from 'components/UIKit';

import reducer from 'containers/Quotation/reducer';
import saga from 'containers/Quotation/saga';

import { printQuotation } from 'containers/Quotation/actions';

import { featureAllowed } from 'containers/App/selectors';
import messages from 'containers/Quotation/messages';
import { FormattedMessageWithClass } from '../../utils/FormattedMessageWithClass';

import './styles.scss';
import 'antComponentsStyle';

const statusTypeMap = {
  OPEN: 'info',
  WON: 'success',
  LOST: 'alert',
};

const statusTextMap = {
  OPEN: 'In corso',
  WON: 'Vinto',
  LOST: 'Perso',
};

const quotationWidget = props => {
  const { quotations, featureAllowed } = props;

  const box = [];

  quotations.map((elem, index) => {
    const { sustainability } = elem;
    let showSalesBot = false;

    try {
      showSalesBot =
        elem.status === 'OPEN' &&
        elem.qualified < 1 &&
        elem.category.id > 10 &&
        elem.crm_id !== undefined;
    } catch (e) {}
    if (!elem.hasAssistant) {
      showSalesBot = false;
    }

    let quotationStep = 1;

    if (elem.code !== null) {
      quotationStep = 3;

      if (elem.hasAttachments) {
        quotationStep = 4;
      }
    } else if (
      sustainability &&
      sustainability.answers &&
      !Array.isArray(sustainability.answers) &&
      Object.keys(sustainability.answers).length > 0
    ) {
      quotationStep = 2;
    }

    const title = `Preventivo #${elem.proposal_id.toString().padStart(5, '0')}`;
    const stepTitleIndex = `step${quotationStep + 1}_title`;
    const stepTitle = messages[stepTitleIndex].defaultMessage;

    const item = (
      <a
        href={`quotations/${elem.proposal_id}`} aria-label="Visualizza dettaglio richiesta"
        className="project-box el-tablo"
        key={index}
      >
        <div className="project-head">
          <div className="project-title">
            {elem.stillValid ?
            <p className="text-medium">{title}</p>
            :
            <ExpiredTooltip>
              <h5>{title} <AlertIcon size="15px" /></h5>
            </ExpiredTooltip>
            }
            <div className="quotation-agent-business-name">Agente: {elem.agent_name}</div>
          </div>
          <Tag
            type={statusTypeMap[elem.status || 'OPEN']}
            text={statusTextMap[elem.status || 'OPEN']}
          />
        </div>
        <div className="project-info">
          <Row className="align-items-center">
            <Col md={4} lg={2} className="pt-md-2">
              <div className="el-tablo highlight">
                <div className="label">Data</div>
                <div className="value">{elem.date}</div>
              </div>
            </Col>
            <Col md={4} lg={2} className="pt-md-2">
              <div className="el-tablo highlight">
                <div className="label">Ragione Sociale</div>
                <div className="value">{elem.customer_name}</div>
              </div>
            </Col>
            <Col md={4} lg={2} className="pt-md-2">
              <div className="el-tablo highlight">
                <div className="label">Automobile</div>
                <div className="value">{elem.car_name}</div>
              </div>
            </Col>
            <Col md={4} lg={2} className="pt-md-2">
              <div className="el-tablo highlight">
                <div className="label">Rata mensile</div>
                <div className="value">
                  &euro;
                  {elem.price.toLocaleString('it')}
                </div>
              </div>
            </Col>
            <Col md={4} lg={2} className="pt-md-2">
              <div className="el-tablo highlight">
                <div className="label">Anticipo</div>
                <div className="value">
                  &euro;
                  {elem.deposit.toLocaleString('it')}
                </div>
              </div>
            </Col>
            {featureAllowed('fees-visibility') &&
              <Col md={4} lg={2} className="pt-md-2">
                <div className="el-tablo highlight">
                  <div className="label">Commissione</div>
                  <div className="value">
                    &euro;
                    {Math.max(0, elem.commission).toLocaleString('it')}
                  </div>
                </div>
              </Col>
            }
          </Row>
          <div id="ProgressWidget" className="mb-md-2 mb-lg-4">
            <Steps size="small" current={quotationStep}>
              <Steps.Step />
              <Steps.Step
                title={
                  <>
                    <FormattedMessageWithClass
                      {...messages.step2_title}
                      className={classnames({
                          "d-none d-xl-block": true,
                        })}
                    />
                    <FormattedMessageWithClass
                      {...messages.step2_title_short}
                      className={classnames({
                        'd-none d-xl-none': true,
                        'd-lg-block': quotationStep === 1,
                      })}
                    />
                  </>
                }
              />
              <Steps.Step
                title={
                  <>
                    <FormattedMessageWithClass
                      {...messages.step3_title}
                      className={classnames({
                        'd-none d-xl-block': true,
                      })}
                    />
                    <FormattedMessageWithClass
                      {...messages.step3_title_short}
                      className={classnames({
                        'd-none d-xl-none': true,
                        'd-lg-block': quotationStep === 2,
                      })}
                    />
                  </>
                }
              />
              <Steps.Step
                title={
                  <>
                    <FormattedMessageWithClass
                      {...messages.step4_title}
                      className={classnames({
                        'd-none d-xl-block': true,
                      })}
                    />
                    <FormattedMessageWithClass
                      {...messages.step4_title_short}
                      className={classnames({
                        'd-none d-xl-none': true,
                        'd-lg-block': quotationStep === 3,
                      })}
                    />
                  </>
                }
              />
              <Steps.Step
                title={
                  <>
                    <FormattedMessageWithClass
                      {...messages.step5_title}
                      className={classnames({
                        'd-none d-xl-block': true,
                      })}
                    />
                    <FormattedMessageWithClass
                      {...messages.step5_title}
                      className={classnames({
                        'd-none d-xl-none': true,
                        'd-lg-block': quotationStep === 4,
                      })}
                    />
                  </>
                }
              />
            </Steps>
            <p className="mt-3 mb-0 d-none d-md-block d-lg-none font-weight-bold" style={{color: '#1890ff', fontSize: '.8em'}}>
              {stepTitle}
            </p>
          </div>
        </div>
      </a>
    );

    box.push(item);
  });

  return (
    <div className="padded-md" id="TableWidgetQuotations">
      <div className="projects-list">{box}</div>
    </div>
  );
};

quotationWidget.propTypes = {
  quotations: PropTypes.any.isRequired,
};

export function mapDispatchToProps(dispatch) {
  return {
    print: quote => dispatch(printQuotation(quote)),
  };
}
const mapStateToProps = createStructuredSelector({
  featureAllowed: (state, featureSlug) => featureAllowed(state, featureSlug),
});

const withReducer = injectReducer({ key: 'quotation', reducer });
const withSaga = injectSaga({ key: 'quotation', saga });

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(quotationWidget);
